import { get } from '@/utils/dom'
import { uniq } from '@/utils/lodash'

const state = {
  aliveComponents: [],
  scrollTop: '',
  aliveComponentsData: {},
}

const getters = {
  aliveComponents: (state) => state.aliveComponents,
  aliveComponentsData: (state) => state.aliveComponentsData,
  scrollTop: (state) => state.scrollTop,
}

const mutations = {
  SET_ALIVE_COMPONENTS: (state, aliveComponents) => {
    state.aliveComponents = uniq(aliveComponents)
  },
  DELETE_ALIVE_COMPONENTS: (state, aliveComponents) => {
    const idx = state.aliveComponents.indexOf(aliveComponents)

    if (idx < 0) {
      return
    }

    state.aliveComponents.splice(idx, 1)
  },
  SET_ALIVE_COMPONENTS_DATA: (state, { key, data }) => {
    state.aliveComponentsData[key] = data
  },
  DELETE_ALIVE_COMPONENTS_DATA: (state, { key }) => {
    delete state.aliveComponentsData[key]
  },
  SET_ALIVE_SCROLL_TOP_BY_DOM: (state, { dom, scrollTop }) => {
    if (!dom) {
      return
    }

    const $dom = get(dom)

    if ($dom && scrollTop) {
      $dom.scrollTop = scrollTop
    }

    state.scrollTop = $dom?.scrollTop || scrollTop
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
